import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

// Delegation survives Shopify section replacement without duplicating handlers.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('[data-bv-cart-add], .bv-home-image-add, #MainContent[data-template="index"] .bv-simple-add, #MainContent[data-template="index"] .bv-home-add')) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[role="alert"]');
  const id = Number(new FormData(form).get('id'));
  const quantity = Number(new FormData(form).get('quantity') || 1);
  if (!id || !button) return;
  form.dataset.busy = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (error) error.hidden = true;
  const update = CartLinesUpdateEvent.createPromise();
  // Dispatch from document: cart components must receive this as an external update.
  const searchDialog = form.closest('#search-modal dialog');
  (searchDialog ? form : document).dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'cart', lines: [{ id: String(id), quantity }], promise: update.promise,
  }));
  try {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map(component => component.dataset.sectionId))].slice(0, 5);
    const response = await fetch(form.action.replace(/\.js$/, '') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: location.pathname }),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || response.statusText);
    const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.json', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store',
    });
    if (!cartResponse.ok) throw new Error(cartResponse.statusText);
    const cart = await cartResponse.json();
    update.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'belvoir-cart-add', didError: false },
    });
    if (searchDialog && document.querySelector('#cart-drawer cart-drawer-component[auto-open]')) {
      document.querySelector('#search-modal')?.closeDialog?.();
    }
  } catch (failure) {
    update.reject(failure);
    document.dispatchEvent(new CartErrorEvent({ error: failure.message, code: 'INVALID' }));
    if (error) { error.textContent = failure.message; error.hidden = false; }
    else {
      const notice = document.createElement('span');
      notice.className = 'bv-cart-add-error'; notice.setAttribute('role', 'alert'); notice.textContent = failure.message;
      form.append(notice);
    }
  } finally {
    delete form.dataset.busy;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
